import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo } from "react"

import { useFallbackEditor, useTextStyleState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface TextColorButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconButton>, "children">, OptionalEditorProps {}

export const TextColorButton = memo<TextColorButtonProps>((props) => {
	const { ref, editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useTextStyleState(editor)

	return (
		<IconButton ref={ref} {...rest}>
			<LuIcon icon={tipTapIconMapping.textColor} color={state.color} />
		</IconButton>
	)
})
TextColorButton.displayName = "TextColorButton"
